import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

export default function EditPwd() {
  const navigate = useNavigate();

  useEffect(() => {
    const authCode = new URLSearchParams(window.location.search).get('code');
    if (authCode) {
      localStorage.setItem('stateFlow', JSON.stringify({ isEditPwd: true }));
      navigate(`/${window.location.search}`, {
        state: {
          isEditPwd: true,
          authCode,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div></div>;
}
